module.exports = __webpack_public_path__ + "img/Get_Started.3cfd08b3.png";